import { Language } from './language';

export const English: Language = {
    loadingDescription: 'Loading templates...',
    addToCart: 'ADD TO CART',
    undo: 'Undo',
    toggleFronts: 'Show/hide fronts',
    removeElement: 'Remove element',
};
